module.exports = __webpack_public_path__ + "assets/img/noResult.a8a4f769.png";